export const SET_DATA_DIRECTORIOS= 'SET_DATA_DIRECTORIOS';
export const GET_DATA_DIRECTORIOS= 'GET_DATA_DIRECTORIOS';

export const seDatatDocumentos = (change) => dispatch =>{
  
    return new Promise((resolve, reject) => {
      try {
        
        dispatch({
          type: SET_DATA_DIRECTORIOS,
          payload: change
        })
        
        resolve({success: true, data: null})
      } catch (err) {
        reject({success: false, err})
      }
    })
    
    
}
export const seDataDirectorio = (change) => dispatch =>{
  
    return new Promise((resolve, reject) => {
      try {
        
        dispatch({
          type: SET_DATA_DIRECTORIOS,
          payload: change
        })
        
        resolve({success: true, data: null})
      } catch (err) {
        reject({success: false, err})
      }
    })
    
    
}
export const setDataDirectorio = (change) => dispatch =>{
  
    return new Promise((resolve, reject) => {
      try {
        
        dispatch({
          type: SET_DATA_DIRECTORIOS,
          payload: change
        })
        
        resolve({success: true, data: null})
      } catch (err) {
        reject({success: false, err})
      }
    })
    
    
}
export const checkDataDirectorio = (change) => dispatch =>{
  // console.log('nnnnnnnnnnnnnnnn222', change)
  return new Promise((resolve, reject) => {
    try {
      let _ss = localStorage.getItem(change);
      let ss = JSON.parse(_ss)
      if (ss !== null) {
        if (ss.time !== undefined) {
          
          if (ss.time !== 0 && (Date.now() - ss.time) < process.env.REACT_APP_TIME_SESSION) {
          // if (ss.time !== 0 && (Date.now() - ss.time) < 450000) {
            //get data sesionstorage
            ss.time = Date.now()
            dispatch({
              type: SET_DATA_DIRECTORIOS,
              payload: ss
            })
            resolve({success: true, data: ss})
          }
        }
        
      }
      resolve({success: false, data: null})
      
    } catch (err) {
      reject({success: false, data: err})
    }
  })


 
  
}

export const getDataDirectorio = (change) => dispatch =>{
  // console.log('getDataDirectorio', change)
  
        //get data sesionstorage
  dispatch({
    type: GET_DATA_DIRECTORIOS,
    payload: {
      session: change
    }
  })
  
}

